import { Button, Modal } from 'antd'
import { isEmpty } from 'lodash'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import Select, { StylesConfig } from 'react-select'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { useStore } from 'src/hooks'

/**
 * Popup duyet viec cho duyet, kem o chon designer khong bat buoc.
 *
 * De trong thi viec chi duoc duyet nhu truoc (chuyen sang Moi, designer nao cung
 * nhan duoc). Chon designer thi server duyet xong giao luon cho nguoi do.
 *
 * Dung chung cho duyet mot viec va duyet nhieu viec, nen phan mo ta do man cha
 * truyen vao. Khong dung `useModal` vi popup do render noi dung bang
 * dangerouslySetInnerHTML nen khong nhet duoc o select vao trong.
 */

type ApproveJobModalProps = {
   open: boolean
   // Mo ta ben tren o chon designer, cho phep chuoi HTML dang <b>...</b>
   description: string
   title?: string
   okText?: string
   loading?: boolean
   onCancel: () => void
   onOk: (designer: any) => void
}

const colourStyles: StylesConfig<true> = {
   control: (styles: any) => ({ ...styles, backgroundColor: 'white' }),
   option: (styles: any, { isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isDisabled
         ? undefined
         : isSelected
         ? 'rgba(54,179,126,0.3);'
         : isFocused
         ? 'rgba(54,179,126,0.1);'
         : undefined,
      color: 'default',
      cursor: 'default',
      ':active': {
         ...styles[':active'],
         backgroundColor: 'rgba(54,179,126,0.3);'
      }
   })
}

const ApproveJobModal: React.FC<ApproveJobModalProps> = observer(
   ({ open, description, title, okText, loading, onCancel, onOk }) => {
      const { t } = useTranslation()
      const UserStore = useStore('UserStore')
      const { listDesigner } = UserStore
      const [designer, setDesigner] = useState<any>(null)

      // Moi lan mo lai popup thi bo designer da chon o lan truoc
      useEffect(() => {
         if (open) setDesigner(null)
      }, [open])

      return (
         <Modal
            visible={open}
            title={title || 'Duyệt việc'}
            onCancel={onCancel}
            destroyOnClose
            footer={[
               <Button key="cancel" onClick={onCancel} disabled={loading}>
                  {t(GLOBAL_CLIENT.huy)}
               </Button>,
               <Button key="ok" type="primary" loading={loading} onClick={() => onOk(designer)}>
                  {okText || t(GLOBAL_CLIENT.dongy)}
               </Button>
            ]}
         >
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <div style={{ marginTop: 16 }}>
               <p style={{ fontWeight: 'bold', marginBottom: 8 }}>{'Giao luôn cho designer (không bắt buộc)'}</p>
               <Select
                  value={designer}
                  options={listDesigner?.rows}
                  onChange={setDesigner}
                  getOptionLabel={(option: any) => (isEmpty(option?.name) ? option?.email : option?.name)}
                  getOptionValue={(option: any) => String(option?.id)}
                  styles={colourStyles}
                  classNamePrefix="select"
                  menuPlacement="auto"
                  isClearable
                  isSearchable
                  placeholder={'-- Chọn designer --'}
               />
               <p style={{ marginTop: 8, marginBottom: 0, color: '#8c8c8c' }}>
                  {'Để trống thì việc chỉ được duyệt, designer nào cũng nhận được.'}
               </p>
            </div>
         </Modal>
      )
   }
)

export default ApproveJobModal
